import { Component, OnInit, OnDestroy, Directive, Input, HostListener, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, NgControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { CognitoUtil } from '../../../../shared/services/cognito.service';
import { CaseService } from '../../../../shared/services/case.service';
import { Case } from '../../../../shared/models/case';
import { CaseContact } from '../../../../shared/models/caseContact';
import { MatColors } from '../../../../../core/matColors';
import { AlertService } from '../../../../shared/services/alert.service';
import { PreSignService } from '../../../../shared/services/preSign.service';
import { LocalUserService } from '../../../../shared/services/localUser';
import { Alert } from '../../../../shared/models/alert';
import 'rxjs/Rx';

@Component({
  selector: 'alertForm',
  templateUrl: './alertForm.component.html',
  providers: [
    AlertService,
    LocalUserService,
    PreSignService
  ],
  styleUrls: ['./alertForm.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertFormComponent implements OnInit {
  @ViewChild('docUpload') myFileInput;
  casesArray: Case[];
  dialogTitle: string;
  alertForm: FormGroup;
  action: string;
  userId: string;
  token: string;
  orgId: string;
  messageTypes = ['Complaint', 'Information', 'Tip'];
  case_id: string;
  subject: string;
  alert: Alert;
  uploadQueue = new MatTableDataSource();
  loading = false;
  displayedColumns: string[] = ['name', 'size', 'type', 'action'];

  constructor(
    public dialogRef: MatDialogRef<AlertFormComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private formBuilder: FormBuilder,
    private cognitoUtil: CognitoUtil,
    private router: Router,
    private alertService: AlertService,
    private caseService: CaseService,
    private localUser: LocalUserService,
    private preSignService: PreSignService
  ) {
    this.dialogTitle = 'ALERT';
    this.alert = data.alert;
    this.casesArray = data.caseList;
    this.alert = new Alert();
    if (this.casesArray.length > 1) {
      this.alertForm = this.createAlertForm();
    } else {
      this.alertForm = this.formControlOneCase();
    }
    this.action = data.action;
  }

  showCases() {
    this.casesArray = this.data.caseList;
    this.casesArray = this.data.caseList;
  }

  ngOnInit() {
    this.userId = this.localUser.getUserId();
    this.orgId = this.localUser.getOrganizationId();
    this.showCases();
  }

  createAlertForm() {
    return new FormGroup({
      message_type: new FormControl(this.alert.message_type, Validators.required),
      message: new FormControl(this.alert.message, Validators.required),
      case_id: new FormControl(this.case_id, Validators.required),
      subject: new FormControl(this.subject, Validators.required)
    });
  }
  formControlOneCase() {
    return new FormGroup({
      message_type: new FormControl(this.alert.message_type, Validators.required),
      message: new FormControl(this.alert.message, Validators.required),
      case_id: new FormControl(this.case_id),
      subject: new FormControl(this.subject, Validators.required)
    });
  }

  addToQueue(event) {
    if (event.target.files.length === 0) {
      return 0;
    }

    let file = event.target.files[0];

    this.uploadQueue.data.push(file);
    this.uploadQueue.data = this.uploadQueue.data;
    this.myFileInput.nativeElement.value = '';
  }

  saveAlert() {
    this.loading = true;
    let alertFormRequest = this.alertForm.value;

    let postAlertData = {
      id: null,
      case_id: alertFormRequest.case_id,
      message: alertFormRequest.message,
      alert_type: alertFormRequest.message_type.toUpperCase(),
      subject: alertFormRequest.subject,
      sent_by: this.userId,
      created_date: new Date(),
      modified_date: new Date(),
      sender_viewed: true,
      organization_viewed: false,
      modified_by: null,
      closed: false
    };

    this.alertService.postAlert(alertFormRequest.case_id, postAlertData)
      .subscribe(result => {
        this.uploadDocuments(result);
      });
  }

  uploadDocuments(alert) {
    let alertId = alert.id;
    let caseId = alert.case_id;
    this.caseService.getCaseById('', caseId)
      .subscribe(data => {
            let orgId = data.summary.organization_id;
            if (this.uploadQueue.data.length === 0) {
              this.loading = false;
              this.dialogRef.close();
            }
            else {
        
              this.uploadQueue.data.forEach((e, index) => {
                this.preSignService.getPresignForAlert(orgId, caseId, alertId, e['name'])
                  .subscribe(result => {
                    this.preSignService.uploadFile(result, e)
                      .subscribe(resultt => {
                        //this.uploadQueue.data.splice(0, 1);
                        // this.uploadDocuments(alert);
                        if (index == this.uploadQueue.data.length - 1) {
                          this.dialogRef.close();
                        }
                      });
                  });
              });
        
        
            }
    }, Error => {
      console.log(Error);
    });

    

  }

  cleanFileType(type) {

    let reg = /\/(.*)$/gm;

    return reg.exec(type)[1];

  }

  cleanFileSize(size) {

    size = size / 1024;
    if (size > 1024) {
      size = size / 1024;
      return size.toFixed(2) + 'MB';
    }
    else {
      return size.toFixed(2) + 'KB';
    }

  }

  removeFile(element) {
    for (let i = 0; i < this.uploadQueue.data.length; i++) {
      if (this.uploadQueue.data[i] === element) {
        this.uploadQueue.data.splice(i, 1);
      }
    }
    this.uploadQueue.data = this.uploadQueue.data;
  }
}








// WEBPACK FOOTER //
// ./src/app/main/content/common/alertList/alertForm/alertForm.component.ts